import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { LangCtx } from "../../../lib/context";

import "../Styles.css";

const WebClinicSideNavLinks = (props) => {
  const location = useLocation();
  const { l } = useContext(LangCtx);

  return (
    <>
      <ul className="flexMinHeightCol overFlowY">
        {/* clinic links */}
        <li className="wsnItem">
          <Link
            to="/corporate-dashboard"
            className={
              location.pathname === "/corporate-dashboard"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/dashboard.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/corporate-createusers"
            onClick={props.hideMenu}
            className={
              location.pathname === "/corporate-createusers"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/create-patient-outlined.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.create_user}</span>
            </div>
          </Link>
        </li>
        {/* <li className="wsnItem">
                    <Link to="/create-patient" className={location.pathname === "/create-patient" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/create-patient.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.cret_new_pat}</span>
                        </div>
                    </Link>
                </li> */}
        {/* <li className="wsnItem">
                    <Link to="/doctor-schedule" className={location.pathname === "/doctor-schedule" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/create-schedule-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.book_apptmnt}</span>
                        </div>
                    </Link>
                </li> */}
        {/* <li className="wsnItem">
                    <Link to="/patients-list" className={location.pathname === "/patients-list" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/patients-list.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.pat_list}</span>
                        </div>
                    </Link>
                </li> */}
        <li className="wsnItem">
          <Link
            to="/corporate-users"
            onClick={props.hideMenu}
            className={
              location.pathname === "/corporate-users"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/group-outlined.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.users}</span>
            </div>
          </Link>
        </li>
        {/* <li className="wsnItem">
          <Link
            to="/appointments"
            className={
              location.pathname === "/appointments"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/appointments-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.apptmnts}</span>
            </div>
          </Link>
        </li> */}
        <li className="wsnItem">
          <Link
            to="/corporate-configraion"
            onClick={props.hideMenu}
            className={
              location.pathname === "/corporate-configraion"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/gear.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard_configuration}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/license-management"
            className={
              location.pathname === "/license-management"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/licenses.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.LicenseManagement}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/edit-profile"
            className={
              location.pathname === "/edit-profile"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/profile-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.my_profile}</span>
            </div>
          </Link>
        </li>


        <li className="wsnItem">
          <Link
            to="/corporate-settings"
            className={
              location.pathname === "/corporate-settings"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/settings-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.settings}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <a className='wsnLink' href="https://help.instavc.com/inconsult" target="_blank">
            <img src='/images/icons/play-button.png' alt='help' className='linkIcon invertWhite' />
            <div className="linkTxtBlock">
              <span>{l.help_center}</span>
            </div>
          </a>
        </li>
      </ul>
      <ul className="flexAutoCol btmGrp">
        <li className="wsnItem">
          <Link
            onClick={props.handleLogout}
            className={
              location.pathname === "/" ? "wsnLink wsnAcitve" : "wsnLink"
            }
          >
            <img
              src="/images/icons/logout-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.logout}</span>
            </div>
          </Link>
        </li>
      </ul>
    </>
  );
};

export default WebClinicSideNavLinks;